import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import { IdeaTopCardButtonsFragment } from './__generated__/IdeaTopCardButtonsFragment';
import MoneyView from 'shared/components/MoneyView';

import './index.scss';

const b = b_.with('idea-top-card-buttons');

interface Props {
  idea: IdeaTopCardButtonsFragment;
}

export const Buttons: React.FC<Props> = ({ idea }) => {
  const { t } = useTranslation();
  return (
    <div className={b()}>
      <button className={b('submit')} data-testid="invest-submit-button">
        {t('Invest from')}
        <span className={b('submit-separator')} />
        <MoneyView precision={0}>{idea.enterAmount}</MoneyView>
      </button>
    </div>
  );
};
